var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.43006V3.79785C20 3.49317 19.7361 3.25378 19.4001 3.25378H15.4889V0.544314C15.4889 0.239635 15.225 0.000244141 14.889 0.000244141H5.11098C4.77505 0.000244141 4.5111 0.239635 4.5111 0.544314V3.25378H0.59988C0.263947 3.25378 0 3.49317 0 3.79785V5.43006H1.69166L2.85543 19.4997C2.87942 19.7826 3.14337 20.0002 3.45531 20.0002H16.5447C16.8566 20.0002 17.1206 19.7826 17.1446 19.4997L18.3083 5.43006H20ZM6.91062 2.17652H13.0774V3.25378H6.91062V2.17652ZM14.877 17.824H5.12298L4.10318 5.41918H15.8968L14.877 17.824Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6137 15.9523H12.8134C13.1374 15.9523 13.4013 15.7129 13.4133 15.4192L13.6413 7.70424C13.6413 7.39956 13.3773 7.14929 13.0414 7.14929H11.8416C11.5177 7.14929 11.2537 7.38868 11.2417 7.68248L11.0138 15.3974C11.0138 15.7021 11.2777 15.9523 11.6137 15.9523Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35878 7.70424L6.58673 15.4192C6.58673 15.7129 6.86267 15.9523 7.18661 15.9523H8.38637C8.7223 15.9523 8.99825 15.7021 8.98625 15.3974L8.7583 7.68248C8.7583 7.38868 8.48235 7.14929 8.15842 7.14929H6.95866C6.62272 7.14929 6.34678 7.39956 6.35878 7.70424Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/TrashCan.73460606c7f81dad977dcc790df54b2b.svg";
export { ForwardRef as ReactComponent };